import styled from 'styled-components'

export const TeamLogo = styled.img`
    height: 260px;
    width: 260px;
    margin: 0 auto 20px auto;

@media(max-width: 1920px){
    height: 220px;
    width: 220px;
    margin: 0 auto;
}

@media(max-height: 900px){
    height:200px;
    width:200px;
}
@media(max-width: 270px){
    height:150px;
    width:150px;
}
`;